import { JensiatEnum } from 'Feature/Common/Common/Types/Enums/JensiatEnum';

import AddressInitialState from '../../EstelamAndSodoor/reducers/InitialStates/AddressInitialState';
import BimehMarkaziInitialStateSodoor from '../../EstelamAndSodoor/reducers/InitialStates/BimehMarkaziInitialStateSodoor';
import { BimehNamehInitialStateSodoor } from '../../EstelamAndSodoor/reducers/InitialStates/BimehNamehInitialStateSodoor';
import SherkatBimehGhablInitialState from '../../EstelamAndSodoor/reducers/InitialStates/SherkatBimehGhablInitialState';
import { VehicleInfoInitialStateSodoor } from '../../EstelamAndSodoor/reducers/InitialStates/VehicleInfoInitialStateSodoor';
import BimehNamehInitialStateEstelam from '../../SodoorBimehNamehByPelak/reducers/InitialStates/BimehNamehInitialStateEstelam';
import VehicleInfoInitialStateEstelam from '../../SodoorBimehNamehByPelak/reducers/InitialStates/VehicleInfoInitialStateEstelam';

import SodoorBimehNamehByTavizPelakSliceType from './SodoorBimehNamehByTavizPelakSliceType';

const SodoorBimehNamehByTavizPelakInitialState: SodoorBimehNamehByTavizPelakSliceType = {
  getCodeShenasehPardakhtShakhsSalesCommand: {
    bimehNameh: BimehNamehInitialStateSodoor,
    ranandehHa: [],
    tarafHayeGharardad: [],
    address: AddressInitialState,
    vasilehNaghlieh: VehicleInfoInitialStateSodoor,
    bimehMarkazi: BimehMarkaziInitialStateSodoor,
    sherkatBimehGhabl: SherkatBimehGhablInitialState,
  },

  isMablaghKharidBimehNamehMoreThanHaghBimeh: false,

  isSuccess: false,
  StepOneData: null,
  StepTwoData: null,
  StepThreeData: null,
  StepFourData: null,
  StepFiveData: null,

  estelamBimehMarkazi: {
    loading: false,
    data: null,
  },
  moddatHayeBimehNameh: {
    loading: false,
    data: [],
  },
  estelamCommand: {
    vehicleInfo: VehicleInfoInitialStateEstelam,
    bimehNameh: BimehNamehInitialStateEstelam,

    shadowFields: {
      vaziatBimehNamehGhabli: true,
      khesaratDaryaftKardehEed: false,
    },
  },
  getAddressWithPostCode: {
    loading: false,
    data: null,
  },
  estelamSabtAhval: {
    loading: false,
    data: {
      naam: '',
      naamKhanevadegi: '',
      jensiat: JensiatEnum.MARD,
      tarikhTavallod: new Date(),
    },
  },

  noePelak: {
    loading: false,
    data: undefined,
  },
  harfHayePelak: {
    loading: false,
    data: [],
  },

  isCommandFilled: false,
  showConfirmFromUser: false,
  estelamResult: {
    loading: false,
    loaded: false,
    data: null,
  },
  tarafHayeGharardad: [],

  anvaeVasilehNaghleyeh: {
    loading: false,
    data: [],
  },
  tarhTakhfif: {
    loading: false,
    data: [],
  },
  taahodatSalesMali: {
    loading: false,
    data: [],
  },
  moredEstefadehHayeKhodro: {
    loading: false,
    data: [],
  },
  brandHa: {
    loading: false,
    data: [],
  },
  tipHa: {
    loading: false,
    data: [],
  },
  anvaePelak: {
    loading: false,
    data: [],
  },

  rangHa: {
    loading: false,
    data: [],
  },
  taahodatSalesSarneshin: {
    loading: false,
    data: undefined,
  },
  taahodatSalesJaani: {
    loading: false,
    data: undefined,
  },

  countries: {
    loading: false,
    data: [],
  },

  anvaeSherkatBimeh: {
    loading: false,
    data: [],
  },

  getCodeShenasehPardakhtShakhsSalesResult: {
    loading: false,
    data: null,
  },

  serialPelaks: {
    loading: false,
    data: [],
  },

  addToOrderResponse: {
    loading: false,
  },
  sodoorWizard: {
    begin: 1,
    end: 5,
    current: 1,
  },
  niazBeEstelamBimehMarkazi: false,

  takhfifHayeJarimehSales: {
    loading: false,
    data: [],
  },

  takhfifHayeJarimehSarneshin: {
    loading: false,
    data: [],
  },

  bimehNamehExpireDateMaxDay: {
    loading: false,
  },

  estelamDarsadTakhfif: {
    loading: false,
    data: null,
  },

  haghBimehPardakhti: 0,

  isDuplicateBimehNamehInOrder: {
    loading: false,
    data: null,
  },

  needToEdit: false,
};

export default SodoorBimehNamehByTavizPelakInitialState;
